import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(() => ({
  bottleDepositHeaderContainer: {
    minHeight: '6.07vh',
    justifyContent: 'center',
  },
  bottleDepositRowContainer: {
    justifyContent: 'flex-start',
  },
  row: {
    justifyContent: 'space-between',
    paddingLeft: '1.1713vw',
  },
  bottleDepositHeaderText: {
    fontSize: rem(0.875),
    '@media(width: 1366px) and (height:768px)': {
      fontSize: rem(1.1232),
    },
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: themeColor.subheaderLight,
    paddingTop: '0.23vh',
  },
  floatRight: {
    float: 'right',
    width: '100%',
    justifyContent: 'flex-end',
    paddingRight: '2vw',
  },
}));
